/**
 * A request's kind in the reader's words (1.8.3, D-1.8.3-4). Every kind from before reads as it always has
 * (`vol.cat.<kind>` — a past "Companion visit" keeps its words); Other reads as the words the office typed, kept
 * exactly as written, and "Other" when a record carries none.
 */
import type { TFunction } from 'i18next';

export function kindWords(t: TFunction, r: { category: string; otherWhat?: string | null }): string {
  if (r.category === 'other') return (r.otherWhat ?? '').trim() || t('book183.plan.other');
  return t(`vol.cat.${r.category}`);
}
